<template>
    <img
            v-if="host && image"
            :alt="title" :src="imagePath" class="game-image"/>
</template>

<script>
    export default {
        props: {
            title: String,
            image: Object,
            size: {
                type: String,
                default: 'full'
            }
        },
        data() {
            return {
                host: null
            }
        },
        created() {
            const env = require('../../.config');

            this.host = env.content.host.slice(0, -1);
        },
        computed: {
            imagePath() {
                let data = this.image.data;

                if (Array.isArray(this.image.data)) {
                    data = data[0];
                }

                if (this.size === 'full') {
                    return this.host + this.image.data.attributes.url;
                }

                return this.host + this.image.data.attributes.formats[this.size].url;
            }
        }
    }
</script>
